import type { MrpInventoryOutgoingWorkOrderLine } from "@/lib/mrp";

export type InventoryWorkOrderReferenceKind = "gpo" | "gso" | "other";

export function inventoryWorkOrderReferenceKind(
  reference: string | null | undefined,
): InventoryWorkOrderReferenceKind | null {
  const trimmed = reference?.trim() ?? "";
  if (trimmed === "") {
    return null;
  }
  const upper = trimmed.toUpperCase();
  if (upper.startsWith("GSO")) {
    return "gso";
  }
  if (upper.startsWith("GPO")) {
    return "gpo";
  }
  return "other";
}

export function inventoryWorkOrderReferencePromiseDate(
  line: Pick<
    MrpInventoryOutgoingWorkOrderLine,
    "reference" | "sales_order_ship_date" | "purchase_order_promise_date"
  >,
): string | null {
  const kind = inventoryWorkOrderReferenceKind(line.reference);
  if (kind === "gso") {
    return line.sales_order_ship_date?.trim() || null;
  }
  if (kind === "gpo") {
    return line.purchase_order_promise_date?.trim() || null;
  }
  return line.sales_order_ship_date?.trim() || line.purchase_order_promise_date?.trim() || null;
}

export function formatInventoryHoverPromiseDate(isoDay: string | null | undefined): string {
  if (isoDay == null || isoDay.trim() === "") {
    return "";
  }
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(isoDay.trim());
  if (match == null) {
    return isoDay.trim();
  }
  const [, year, month, day] = match;
  return `${month}-${day}-${year}`;
}

export function inventoryWorkOrderHoverLineKey(line: MrpInventoryOutgoingWorkOrderLine): string {
  return [
    line.build_order_id ?? line.work_order_no,
    line.finished_good_sku,
    line.quantity,
    line.demand_kind ?? "",
  ].join(":");
}
